// extracted by mini-css-extract-plugin
module.exports = {"text":"_3Skqsy1zTdl6sB7qUQN6G"};